(function() {
    $(document).ready(function() {

        $('.mod24SecondaryCta .c24Button').on('click', function() {

            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'cta:secondary',
                'cta:compare',
            ]);
        });

        $('.mod24MobileMiniAc form').on('submit', function() {
            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'cta:mini',
                'cta:compare',
            ]);
        });

    });
})();
